import { oneOf } from './extracted';
import type { Locale } from 'common/types/locale';

// Spelled out rather than built from `common/types/locale`'s `locales`: that
// array comes from a Flow module, so it reaches TypeScript as `any`, and an enum
// of an `any` infers `any` -- every field reading a locale would quietly lose
// its type. `satisfies` ties the list back to `Locale` instead.
//
// Order matches `config/webpack/availableLocales`: `oneOf` falls back to the
// first entry, Finnish, and reports.
export const LOCALES = [
  'fi',
  'sv',
  'en',
  'da',
  'pl',
  'es',
  'de',
  'tra'
] as const satisfies readonly Locale[];

export const locale = oneOf(LOCALES);
